// extracted by mini-css-extract-plugin
module.exports = {"root":"SearchableDdl-module__root__lditV"};